/**
 * Same behavior as `utilities.isEqual` from `@cornerstonejs/core` (numeric / array tolerance).
 * Prefer importing `utilities` from `@cornerstonejs/core` in extension code.
 */
import { utilities } from '@cornerstonejs/core';

export default utilities.isEqual;
